<template>

    <div class="site-search__results" v-if="results.length" v-cloak>
        <template v-for="(result, resultIndex) in results" :key="resultIndex">
            <a class="search-result" :href="result.url" :class="[
                `search-result--${result.collectionType}`,
                result.image && result.collectionType !== 'pages' && 'search-result--has-image']"
            >
                <div class="search-result__container" v-if="result.collectionType === 'events'" v-cloak>
                    <div class="event-item">
                        <div class="event-item__content">
                            <figure class="event-item__media" v-if="result.image">
                                <picture class="event-item__intrinsic-ratio">
                                    <img class="event-item__image"
                                         :src="result.image.src"
                                         :alt="result.image.alt"
                                         loading="lazy"
                                    />
                                </picture>
                            </figure>

                            <div class="event-item__details">
                                <!-- <p class="event-item__prefix" v-if="result.prefix">{{ result.prefix }}</p> -->
                                <h3 class="event-item__title">{{ result.title }}</h3>
                                <!-- <p class="event-item__suffix" v-if="result.suffix">{{ result.suffix }}</p> -->

                                <!-- <p class="event-item__location">
                                    {{ formatEventTime(result.data.startDate) }}
                                    {{ formatEventDateFull(result.data.startDate) }}
                                    <template v-if="result.data?.venue?.title">
                                        at
                                        {{ result.data.venue.title }}
                                    </template>
                                </p> -->

                                <div class="event-item__dates">
                                    <div class="event-item__footer" v-if="result.categories && result.categories.length">
                                        <ul class="event-item__categories">
                                            <li class="event-item-category" v-for="(category, catIndex) in result.categories" :key="catIndex">
                                                {{ category.category }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="search-result__container" v-else-if="result.collectionType === 'posts'" v-cloak>
                    <div class="article-item">
                        <div class="search-result__body">
                            <figure class="search-result__media" v-if="result.image">
                                <picture class="search-result__intrinsic-ratio">
                                    <img class="search-result__image"
                                         :src="result.image.src"
                                         :alt="result.image.alt"
                                         loading="lazy"
                                    />
                                </picture>
                            </figure>
                            <div class="search-result__content">
                                <p class="search-result__type">{{ result.collectionType }}</p>
                                <h2 class="search-result__title">{{ result.title }}</h2>
                                <div class="search-result__footer">
                                    <span class="search-result-post__date">Posted {{formatDateDisplay(result.startDate) }}</span>
                                    <p class="search-result__author" v-if="result.authors">By {{ result.authors }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="search-result__container" v-else v-cloak>
                    <div class="page-item">
                        <div class="search-result__body">
                            <figure class="search-result__media" v-if="result.image">
                                <picture class="search-result__intrinsic-ratio">
                                    <img class="search-result__image"
                                         :src="result.image.src"
                                         :alt="result.image.alt"
                                         loading="lazy"
                                    />
                                </picture>
                            </figure>
                            <div class="search-result__content">
                                <p class="search-result__type" v-if="result.collectionType !== 'pages'">
                                {{ result.collectionType }}
                                </p>
                                <h2 class="search-result__title">{{ result.title }}</h2>
                                <p class="search-result__description" v-if="result.description" v-html="result.description" />
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </template>
    </div>
</template>

<script setup>
import {formatPostDate, formatEventDateFull, formatEventTime } from "../utils/date-formatters.mjs";
import {useState} from "../services/stateful";

const formatDateDisplay = useState('SearchResult.Format.DateDisplay', formatPostDate);

const props = defineProps({
    results: {
        type: Array,
        required: true
    }
});

</script>


<style scoped>

</style>
